import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from 'src/app/shared/shared.module'
import { OffersListComponent } from './pages/offers-list/offers-list.component'
import { AddPromoCodeComponent } from './pages/add-promo-code/add-promo-code.component'
import { OfferRoutingModule } from './offer-routing.module'
import {
  AddPromoCodeBasicInfoComponent,
} from './components/add-promo-code-basic-info/add-promo-code-basic-info.component'
import {
  AddPromoCodeCountryPriceComponent,
} from './components/add-promo-code-country-price/add-promo-code-country-price.component'
import { OffersTableComponent } from './components/offers-table/offers-table.component'
import { ViewPromoCodeComponent } from './pages/view-promo-code/view-promo-code.component'

@NgModule({
	declarations: [
		OffersListComponent,
		AddPromoCodeComponent,
		OffersTableComponent,
		AddPromoCodeBasicInfoComponent,
		AddPromoCodeCountryPriceComponent,
		ViewPromoCodeComponent,
	],
	imports: [CommonModule, OfferRoutingModule, SharedModule],
	exports: [AddPromoCodeComponent, ViewPromoCodeComponent],
})
export class OfferModule {}
